module.exports = __webpack_public_path__ + "static/media/b2_p1_clickable_tf.5fafc5cb.png";